import ErrorInspector from './ErrorInspector';

export default ErrorInspector;
